import { render } from "./SideQueryOverlay.vue?vue&type=template&id=538d2acc"
import script from "./SideQueryOverlay.vue?vue&type=script&lang=js"
export * from "./SideQueryOverlay.vue?vue&type=script&lang=js"

import "./SideQueryOverlay.vue?vue&type=style&index=0&id=538d2acc&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QFab from 'quasar/src/components/fab/QFab.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QFab,QTooltip});
